import { DataSourceExecutionEvent } from "@mcleod/components";
import { AutogenLayoutMobileCommControlPortal } from "./autogen/AutogenLayoutMobileCommControlPortal";
import { MobileCommControlUtils } from "./MobileCommControlUtils";

export class MobileCommControlPortal extends AutogenLayoutMobileCommControlPortal {

    async onLoad() {
        this.mainDataSource.addAfterExecutionListener((event: DataSourceExecutionEvent) => {
            this.iframe1.src = MobileCommControlUtils.getWebURL(this.mainDataSource?.activeRow.get("id") || "");
        });
    }
}
